import React, { useContext } from 'react';
import {
	ICreateComboGroupContext,
	CreateComboGroupContext,
} from '../../../createComboGroupState/createComboGroupContext';
import { MenuTranslationForm } from 'components/TranslationForm/MenuTranslationForm';

interface ITranslationsForm {
	isVisible: boolean;
}

const TranslationsForm: React.FC<ITranslationsForm> = ({ isVisible }) => {
	const {
		setFetchedTranslations,
		setTranslationTab,
		changeNameTranslation,
		selectedCustomer,
		translations,
		selectedTranslationTab,
	} = useContext<ICreateComboGroupContext>(CreateComboGroupContext);
	return (
		<MenuTranslationForm
			setFetchedTranslations={setFetchedTranslations}
			setTranslationTab={setTranslationTab}
			changeNameTranslation={changeNameTranslation}
			isVisible={isVisible}
			IDSelectedCustomer={selectedCustomer}
			translations={translations}
			selectedTranslationTab={selectedTranslationTab}
		/>
	);
};

export default TranslationsForm;
